import {
  TEMPLATE_CREATE_SMS_TEMPLATE_BEGIN,
  TEMPLATE_CREATE_SMS_TEMPLATE_SUCCESS,
  TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE,
  TEMPLATE_CREATE_SMS_TEMPLATE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function createSmsTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_CREATE_SMS_TEMPLATE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates`,
        args.values,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: TEMPLATE_CREATE_SMS_TEMPLATE_SUCCESS,
              data: res.data,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          dispatch({
            type: TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateSmsTemplateError() {
  return {
    type: TEMPLATE_CREATE_SMS_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_CREATE_SMS_TEMPLATE_BEGIN:
      return {
        ...state,
        createSmsTemplatePending: true,
        createSmsTemplateError: null,
      };

    case TEMPLATE_CREATE_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        createSmsTemplatePending: false,
        createSmsTemplateError: null,
      };

    case TEMPLATE_CREATE_SMS_TEMPLATE_FAILURE:
      return {
        ...state,
        createSmsTemplatePending: false,
        createSmsTemplateError: action.data.error,
      };

    case TEMPLATE_CREATE_SMS_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        createSmsTemplateError: null,
      };

    default:
      return state;
  }
}
